import _Vue from 'vue';

// Export Used Vuetify Components
export {
  VApp as AiApp,
  VAppBar as AiAppBar,
  VAppBarNavIcon as AiAppBarNavIcon,
  VAlert as AiAlert,
  VAutocomplete as AiAutocomplete,
  VAvatar as AiAvatar,
  VBadge as AiBadge,
  VBanner as AiBanner,
  VBottomNavigation as AiBottomNavigation,
  VBottomSheet as AiBottomSheet,
  VBreadcrumbs as AiBreadcrumbs,
  VBreadcrumbsItem as AiBreadcrumbsItem,
  VBreadcrumbsDivider as AiBreadcrumbsDivider,
  VBtnToggle as AiBtnToggle,
  VCalendar as AiCalendar,
  VCalendarCategory as AiCalendarCategory,
  VCalendarDaily as AiCalendarDaily,
  VCalendarWeekly as AiCalendarWeekly,
  VCalendarMonthly as AiCalendarMonthly,
  VCard as AiCard,
  VCardTitle as AiCardTitle,
  VCardSubtitle as AiCardSubtitle,
  VCardActions as AiCardActions,
  VCardText as AiCardText,
  VCarousel as AiCarousel,
  VCarouselItem as AiCarouselItem,
  VCheckbox as AiCheckbox,
  VSimpleCheckbox as AiSimpleCheckbox,
  VChip as AiChip,
  VChipGroup as AiChipGroup,
  VColorPicker as AiColorPicker,
  VColorPickerSwatches as AiColorPickerSwatches,
  VColorPickerCanvas as AiColorPickerCanvas,
  VContent as AiContent,
  VCombobox as AiCombobox,
  VCounter as AiCounter,
  VData as AiData,
  VDataIterator as AiDataIterator,
  VDataFooter as AiDataFooter,
  VDataTable as AiDataTable,
  VEditDialog as AiEditDialog,
  VTableOverflow as AiTableOverflow,
  VDataTableHeader as AiDataTableHeader,
  VSimpleTable as AiSimpleTable,
  VVirtualTable as AiVirtualTable,
  VVirtualScroll as AiVirtualScroll,
  VDatePicker as AiDatePicker,
  VDatePickerTitle as AiDatePickerTitle,
  VDatePickerHeader as AiDatePickerHeader,
  VDatePickerDateTable as AiDatePickerDateTable,
  VDatePickerMonthTable as AiDatePickerMonthTable,
  VDatePickerYears as AiDatePickerYears,
  VDialog as AiDialog,
  VDivider as AiDivider,
  VExpansionPanels as AiExpansionPanels,
  VExpansionPanel as AiExpansionPanel,
  VExpansionPanelHeader as AiExpansionPanelHeader,
  VExpansionPanelContent as AiExpansionPanelContent,
  VFileInput as AiFileInput,
  VFooter as AiFooter,
  VForm as AiForm,
  VContainer as AiContainer,
  VCol as AiCol,
  VRow as AiRow,
  VSpacer as AiSpacer,
  VLayout as AiLayout,
  VFlex as AiFlex,
  VHover as AiHover,
  VImg as AiImg,
  VInput as AiInput,
  VItem as AiItem,
  VItemGroup as AiItemGroup,
  VLabel as AiLabel,
  VLazy as AiLazy,
  VListItemActionText as AiListItemActionText,
  VListItemContent as AiListItemContent,
  VListItemTitle as AiListItemTitle,
  VListItemSubtitle as AiListItemSubtitle,
  VList as AiList,
  VListGroup as AiListGroup,
  VListItem as AiListItem,
  VListItemAction as AiListItemAction,
  VListItemAvatar as AiListItemAvatar,
  VListItemIcon as AiListItemIcon,
  VListItemGroup as AiListItemGroup,
  VMain as AiMain,
  VMessages as AiMessages,
  VNavigationDrawer as AiNavigationDrawer,
  VOverflowBtn as AiOverflowBtn,
  VOverlay as AiOverlay,
  VPagination as AiPagination,
  VSheet as AiSheet,
  VParallax as AiParallax,
  VPicker as AiPicker,
  VProgressCircular as AiProgressCircular,
  VProgressLinear as AiProgressLinear,
  VRadioGroup as AiRadioGroup,
  VRadio as AiRadio,
  VRangeSlider as AiRangeSlider,
  VRating as AiRating,
  VResponsive as AiResponsive,
  VSelect as AiSelect,
  VSkeletonLoader as AiSkeletonLoader,
  VSlider as AiSlider,
  VSlideGroup as AiSlideGroup,
  VSlideItem as AiSlideItem,
  VSnackbar as AiSnackbar,
  VSparkline as AiSparkline,
  VSpeedDial as AiSpeedDial,
  VStepper as AiStepper,
  VStepperContent as AiStepperContent,
  VStepperStep as AiStepperStep,
  VStepperHeader as AiStepperHeader,
  VStepperItems as AiStepperItems,
  VSubheader as AiSubheader,
  VSwitch as AiSwitch,
  VSystemBar as AiSystemBar,
  VTabs as AiTabs,
  VTab as AiTab,
  VTabItem as AiTabItem,
  VTabsItems as AiTabsItems,
  VTabsSlider as AiTabsSlider,
  VTextarea as AiTextarea,
  VTextField as AiTextField,
  VTimeline as AiTimeline,
  VTimelineItem as AiTimelineItem,
  VTimePicker as AiTimePicker,
  VTimePickerClock as AiTimePickerClock,
  VTimePickerTitle as AiTimePickerTitle,
  VToolbar as AiToolbar,
  VToolbarItems as AiToolbarItems,
  VToolbarTitle as AiToolbarTitle,
  VTooltip as AiTooltip,
  VTreeview as AiTreeview,
  VTreeviewNode as AiTreeviewNode,
  VWindow as AiWindow,
  VWindowItem as AiWindowItem,
  VCarouselTransition as AiCarouselTransition,
  VCarouselReverseTransition as AiCarouselReverseTransition,
  VTabTransition as AiTabTransition,
  VTabReverseTransition as AiTabReverseTransition,
  VMenuTransition as AiMenuTransition,
  VMenu as AiMenu,
  VFabTransition as AiFabTransition,
  VDialogTransition as AiDialogTransition,
  VDialogBottomTransition as AiDialogBottomTransition,
  VFadeTransition as AiFadeTransition,
  VScaleTransition as AiScaleTransition,
  VScrollXTransition as AiScrollXTransition,
  VScrollXReverseTransition as AiScrollXReverseTransition,
  VScrollYTransition as AiScrollYTransition,
  VScrollYReverseTransition as AiScrollYReverseTransition,
  VSlideXTransition as AiSlideXTransition,
  VSlideXReverseTransition as AiSlideXReverseTransition,
  VSlideYTransition as AiSlideYTransition,
  VSlideYReverseTransition as AiSlideYReverseTransition,
  VExpandTransition as AiExpandTransition,
  VExpandXTransition as AiExpandXTransition,
  VIcon // Levae this as is
} from 'vuetify/lib';

// Export AiDragger Components
export { default as AiDragger } from 'vuedraggable';

// Export Core Components
export { default as AiBtn } from './AiBtn/AiBtn.vue';
export { default as AiDrawer } from './AiDrawer/AiDrawer.vue';
export { default as AiMenuList } from './AiMenuList/AiMenuList.vue';
export { default as AiIcon } from './AiIcon/AiIcon.vue';
export { default as AiIconSvg } from './AiIconSvg/AiIconSvg.vue';
export { default as AiModal } from './AiModal/AiModal.vue';
export { default as AiNav } from './AiNav/AiNav.vue';
export { default as AiNavActions } from './AiNavActions/AiNavActions.vue';
export { default as AiNavGrid } from './AiNavGrid/AiNavGrid.vue';
export { default as AiLabelSelector } from './AiLabelSelector/AiLabelSelector.vue';
export { default as AiColorSelector } from './AiColorSelector/AiColorSelector.vue';
export { default as AiForegroundLoader } from './AiForegroundLoader/AiForegroundLoader.vue';
export { default as AiSliderInput } from './AiSliderInput/AiSliderInput.vue';

// Assigning exported components into a variable
import * as components from './index';

const ComponentLibrary = {
  install(Vue: typeof _Vue) {
    // Font Lato
    const latoLink = document.createElement('link');
    latoLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/3.0.0/css/lato-font.min.css';
    latoLink.integrity =
      'sha512-rSWTr6dChYCbhpHaT1hg2tf4re2jUxBWTuZbujxKg96+T87KQJriMzBzW5aqcb8jmzBhhNSx4XYGA6/Y+ok1vQ==';
    latoLink.crossOrigin = 'anonymous';
    latoLink.rel = 'stylesheet';

    // Font Merriweather
    const googlePreConnect = document.createElement('link');
    googlePreConnect.rel = 'preconnect';
    googlePreConnect.href = 'https://fonts.gstatic.com';

    const merriweatherLink = document.createElement('link');
    merriweatherLink.href =
      'https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap';
    merriweatherLink.rel = 'stylesheet';

    // Injecting CDN fonts to <head>
    document.getElementsByTagName('head')[0].appendChild(latoLink);
    document.getElementsByTagName('head')[0].appendChild(googlePreConnect);
    document.getElementsByTagName('head')[0].appendChild(merriweatherLink);

    // Font Merriweather
    Object.entries(components).forEach(component => {
      Vue.component(component[0], component[1]);
    });

    return components;
  }
};

// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(ComponentLibrary);
// }

_Vue.use(ComponentLibrary);

export default ComponentLibrary;
